import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TimesheetComponent } from './timesheet.component'
import { NgSelectModule } from '@ng-select/ng-select';
import { GridModule, ReorderService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ClientParentModule } from '../client-parent/client-parent.module'
import { PageService, SortService, FilterService, GroupService } from '@syncfusion/ej2-angular-grids';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { TimesheetRoutingModule } from './timesheet-routing.module';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { TimesheetViewComponent } from './timesheet-view/timesheet-view.component';
import { TimesheetEntryComponent } from './timesheet-entry/timesheet-entry.component';
@NgModule({
  declarations: [TimesheetComponent, TimesheetEntryComponent, TimesheetViewComponent],
  imports: [
    TimesheetRoutingModule,
    CommonModule,
    PdfViewerModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    ClientParentModule,
    ToolbarModule,
    DropDownListAllModule,
    MyDatePickerModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    dropdownModule,
  ],
  providers: [PageService,
    SortService,
    ResizeService,
    FilterService,
    GroupService,
  ReorderService],
  exports: [TimesheetComponent]
})
export class TimesheetModule { }
